import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'emotion';
import Flexbox from 'flexbox-react';
import AbstractForm from 'components/page/process/AbstractForm';
import InputDatastreamsField from 'components/core/fields/InputDatastreamsField';
import OutputDatastreamsField from 'components/core/fields/OutputDatastreamsField';

/**
 * The form that renders inputs and outputs for processes that are not using variable retrieval
 * (mainly VAPs).
 */
export default class InputsOutputsForm extends AbstractForm {

    static propTypes = {
        process: PropTypes.object,
        processErrors: PropTypes.object,
        hasWritePermissions: PropTypes.bool,
        dods: PropTypes.array
    };

    render() {
        const rowMarginBottom = '16px';
        const labelWidth = '160px';
        const inputFieldStyles = css`
            margin-bottom: ${rowMarginBottom};
            .infobox {
                width: ${labelWidth};
            }
        `;

        const outputFieldStyles = css`
            padding-top: 8px;
            .infobox {
                width: ${labelWidth};
            }
        `;

        return (
            <Flexbox className="inputs-outputs-form" flexDirection="column" padding="10px 10px 10px 20px" maxWidth="1200px" flexGrow={1}>

                {/* Input Datastreams/Folders */}
                <InputDatastreamsField
                    process={this.props.process}
                    processErrors={this.props.processErrors}
                    hasWritePermissions={this.props.hasWritePermissions}
                    dods={this.props.dods}
                    className={inputFieldStyles}
                />

                {/* Output Datastreams */}
                <OutputDatastreamsField
                    process={this.props.process}
                    processErrors={this.props.processErrors}
                    hasWritePermissions={this.props.hasWritePermissions}
                    dods={this.props.dods}
                    className={outputFieldStyles}
                />
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/page/process/InputsOutputsForm.js